import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import Swiper from "react-id-swiper";
import config from "../../config";
import Package from "../Package";
import "./PackageSlider.scss"; // @TODO find a better name for the "view" props

export var PackageSlider = function PackageSlider(a) {
  var b = a.packages,
      c = void 0 === b ? [] : b,
      d = a.title,
      e = a.disableClicks,
      f = _objectWithoutProperties(a, ["packages", "title", "disableClicks"]);

  return c.length ? (c = c.slice(0, 20), /*#__PURE__*/React.createElement("section", {
    className: "packageslider"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement("h4", null, d), /*#__PURE__*/React.createElement(Swiper, {
    setWrapperSize: !0,
    slidesPerView: 3,
    spaceBetween: 48,
    slideClass: "package",
    loop: !0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      992: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      1680: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        slidesPerView: 2,
        spaceBetween: 48
      }
    }
  }, c.map(function (a, b) {
    return /*#__PURE__*/React.createElement(Package, {
      key: b,
      package: a,
      isSlider: !0,
      disableClicks: !0,
      view: config.routes.get("houseandland")
    });
  })))))) : null;
};
export default PackageSlider;